import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import SectionTitleTwo from '../../components/SectionTitle/SectionTitleTwo';
import SingleTeamThree from '../../components/Team/SingleTeamThree';
import { useCollections } from '../../lib/api/collections';
import { personPhoto } from '../../data/images';
import PrevArrow from '../../components/SVG/PrevArrow';
import NextArrow from '../../components/SVG/NextArrow';


const deptShort = {
  'Banking and Finance': 'Banking & Finance',
  'Insurance and Risk Management': 'Insurance & Risk',
  'Regional Science and Planning': 'Regional Science',
};
const lecturerNames = [
  'Prof. Sunil Chandrasiri',
  'Prof. Sirimal Abeyratne',
  'Prof. J.A. Karunarathna',
  'Prof. G.H. Henegedara',
  'Dr. Maringa Sumanadasa',
  'Dr. Faheema Saheed',
  'Dr. Yan Shuwen',
  'Dr. Thakshila Jayatilake',
];

const Team = () => {
  const { staff } = useCollections('staff');
  if (!staff) return null;
  const lecturers = lecturerNames
    .map((name) => staff.find((p) => p.fullName === name))
    .filter(Boolean)
    .map((p) => ({ ...p, designation: p.rank + ', ' + (deptShort[p.department] || p.department) }));
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '4',
    spaceBetween: 50,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      1400: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: {
      prevEl: '.slider-prev',
      nextEl: '.slider-next',
    },
  };
  return (
    <div
      id="it-team"
      className="ed-team-area grey-bg-4 p-relative fix z-index pt-110 pb-90"
    >
      <div className="container">
        <div className="it-team-title-wrap mb-40">
          <div className="row align-items-center">
            <div className="col-xl-6">
              <SectionTitleTwo
                itemClass="it-team-title-box"
                subtitleClass="it-section-subtitle-5 orange"
                icon="fa-light fa-book"
                subtitle="Our Team"
                titleClass="ed-section-title"
                title="Meet Our Lecturers"
              />
            </div>
            <div className="col-xl-6">
              <div className="ed-team-arrow-box text-end">
                <button className="slider-prev">
                  <PrevArrow />
                </button>
                <button className="slider-next">
                  <NextArrow />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="ed-team-wrapper">
          <div className="swiper-container ed-team-active">
            <Swiper
              modules={[Autoplay, Navigation]}
              {...sliderOption}
              className="swiper-wrapper"
            >
{lecturers.map((p) => (
                <SwiperSlide key={p.fullName} className="swiper-slide">
                  <SingleTeamThree
                    teamImage={personPhoto(p)}
                    authorName={p.displayName}
                    designation={p.designation}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Team;
